<template>
  <div class="pop-box list">
    <div class="pop-title" ref="popTitle">
      <span class="icons ticket">{{ $t('activitypage.text27') }}</span>
    </div>
    <div class="pop-content" :style="{ height: scrollHeight + 'px' }">
      <template v-if="ticketList && ticketList.length > 0">
        <div v-for="(item, index) in ticketList" :key="index">
          <div class="flexable tickets">
            <div class="label">
              <span class="num">#{{ index + 1 }}</span
              ><span>{{ item.created_at }}</span>
            </div>
            <div class="val">
              {{ $t('activitypage.text28') }} <b>{{ item.web5_score }}</b>
              {{ $t('token') }}
            </div>
          </div>
          <template v-if="type === 1">
            <div
              class="score-list disabled"
              v-for="(item, index) in item.join_options"
              :key="index">
              <div class="flexable">
                <div
                  class="name"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + item.home_image + ')'
                  }">
                  {{ item.home_team }}
                </div>
                <div class="vs">VS</div>
                <div
                  class="name"
                  :style="{
                    backgroundImage:
                      'url(' + $store.state.imgUrl + item.away_image + ')'
                  }">
                  {{ item.away_team }}
                </div>
              </div>
              <div class="score-box flexable readyonly">
                <div class="box">{{ item.home_score }}</div>
                <div class="m">:</div>
                <div class="box">{{ item.away_score }}</div>
              </div>
            </div>
          </template>
          <template v-if="type === 2">
            <div class="a2">
              <div
                class="score-list type2 disabled"
                v-for="(item, index) in item.join_options"
                :key="index">
                <div class="flexable">
                  <div
                    class="a"
                    :style="{
                      backgroundImage:
                        'url(' + $store.state.imgUrl + item.player_image + ')'
                    }"></div>
                  <div class="in">
                    <div class="n">{{ item.player_name }}</div>
                    <div class="d">{{ $t('activitypage.text15') }}</div>
                  </div>
                  <div
                    class="num"
                    @click="
                      handleToSelect(
                        'top_scorer_options',
                        'player_score',
                        index
                      )
                    ">
                    {{ item.player_score }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="type === 3">
            <div class="a3">
              <div class="box-list">
                <div class="flexable">
                  <div
                    class="flag"
                    :style="{
                      backgroundImage:
                        'url(' + $store.state.imgUrl + item.championImage + ')'
                    }"></div>
                  <div class="name">
                    {{ item.championName }} {{ $t('activitypage.text16') }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
      <EmptyBox
        v-if="ticketList && ticketList.length === 0"
        type="ticket"
        :text="$t('activitypage.text29')" />
    </div>
  </div>
</template>
<script>
import EmptyBox from '@/components/EmptyBox.vue'

export default {
  components: { EmptyBox },
  props: {
    type: {
      type: Number,
      default: () => null
    },
    list: {
      type: Array,
      default: () => []
    },
    countries: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    list: {
      handler(n, o) {
        console.log(n)
        console.log(o)
        this.init(n)
      },
      deep: true
    }
  },
  data() {
    return {
      ticketList: null,
      scrollHeight: 0
    }
  },
  created() {
    this.init(this.list)
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollHeight =
        document.documentElement.clientHeight -
        this.$refs.popTitle.clientHeight -
        this.$store.state.remTopx * (0.4 + 0.06)
    })
  },
  methods: {
    init(list) {
      this.ticketList = list.map((item) => {
        let champion = this.countries.find((item2) => {
          return item2.id === parseInt(item.champion)
        })
        if (champion) {
          item.championName = champion.name
          item.championImage = champion.image
        }
        return item
      })
    },
    loadMore() {
      alert(1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tickets.vue